export default __webpack_public_path__ + "d6900208b83b656612eefa36f87bb368.png";